// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4921":"8a776929","9505":"c6781a72"}[chunkId] + ".chunk.css";
};